// extracted by mini-css-extract-plugin
export var aiStarIcon = "_m0-2";
export var container = "_m0-4";
export var dismissButton = "_m0-3";
export var hasPaddingBottom = "_m0-6";
export var last = "_m0-e";
export var scrollbarThumb = "_m0-c";
export var scrollbarTrack = "_m0-b";
export var selected = "_m0-9";
export var spin = "_m0-1";
export var spinning = "_m0-0";
export var suggestionItem = "_m0-d";
export var suggestionsPanel = "_m0-5";
export var tonePill = "_m0-8";
export var tonesContainer = "_m0-7";
export var unselected = "_m0-a";